'use strict';

module.exports = {
  maxDateTimestamp: 9223368436850, // it's the same as pandas max timestamp
};
